import { Button, Flex, Form, Input, Select, Switch } from "antd";
import { useEffect } from "react";

const UserForm = ({ editData, saveData, roles = [] }) => {
  const [form] = Form.useForm();

  const isEdit = Boolean(editData);

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        username: editData.username,
        email: editData.email,
        mobileNumber: editData.mobileNumber,
        role: editData.role?.uuid,
        active: editData.active,
        avatarUrl: editData.avatarUrl,
      });
    } else {
      form.resetFields();
    }
  }, [editData, form]);

  const onFinish = (data) => {
    const payload = {
      ...editData,
      ...data,
      role: { uuid: data.role }, // backend expects RoleDTO
    };

    saveData(payload).then((success) => {
      if (success) {
        form.resetFields();
      }
    });
  };

  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
      style={{ maxWidth: 600 }}
      onFinish={onFinish}
    >
      <Form.Item
        label="Username"
        name="username"
        rules={[{ required: true, message: "Please enter username!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Please enter email!" },
          { type: "email", message: "Enter a valid email!" },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Mobile Number"
        name="mobileNumber"
        rules={[
          { required: true, message: "Please enter mobile number!" },
          { pattern: /^[0-9]{10}$/, message: "Enter valid 10-digit number!" },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Role"
        name="role"
        rules={[{ required: true, message: "Please select a role!" }]}
      >
        <Select placeholder="Select role">
          {roles.map((role) => (
            <Select.Option key={role.uuid} value={role.uuid}>
              {role.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      {!isEdit && (
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please enter password!" }]}
        >
          <Input.Password />
        </Form.Item>
      )}

      <Form.Item
        label="Active"
        name="active"
        valuePropName="checked"
        initialValue={true}
      >
        <Switch />
      </Form.Item>

      <Form.Item label="Avatar URL" name="avatarUrl">
        <Input placeholder="https://example.com/avatar.png" />
      </Form.Item>

      <Flex justify="end">
        <Button type="primary" htmlType="submit">
          {isEdit ? "Update" : "Create"}
        </Button>
      </Flex>
    </Form>
  );
};

export default UserForm;
